/* =========================================================================
   assets/popup.js
   Acesso Reservado: pop-up de captura em etapa única
   (nome + telefone com DDI/bandeira + e-mail).
   Gatilho: 20s de navegação OU 50% de scroll. Uma vez por visitante.
   ========================================================================= */

class ReservedAccessPopup extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('dialog');
    this.storageKey = this.dataset.storageKey || 'fea.reserved.seen';
    this.delay = parseInt(this.dataset.delay || '20000', 10);
    this.scrollRatio = parseFloat(this.dataset.scrollRatio || '0.5');

    if (this.seen()) return;

    this.querySelectorAll('[data-popup-close]').forEach((btn) => btn.addEventListener('click', () => this.dismiss()));
    this.dialog.addEventListener('click', (event) => {
      if (event.target === this.dialog) this.dismiss();
    });
    this.dialog.addEventListener('cancel', () => this.dismiss());

    this.timer = setTimeout(() => this.show(), this.delay);
    this.onScroll = this.onScroll.bind(this);
    window.addEventListener('scroll', this.onScroll, { passive: true });

    /* Detecta o país do navegador para pré-selecionar o DDI. */
    const select = this.querySelector('[data-country-select]');
    if (select) {
      const region = (navigator.language || '').split('-')[1];
      if (region && select.querySelector(`option[data-region="${region}"]`)) {
        select.value = select.querySelector(`option[data-region="${region}"]`).value;
      }
    }

    /* Após envio bem-sucedido o Shopify redireciona com ?customer_posted=true */
    if (new URLSearchParams(location.search).get('customer_posted') === 'true') {
      this.markSeen();
    }
  }

  onScroll() {
    const scrolled = window.scrollY / (document.body.scrollHeight - window.innerHeight || 1);
    if (scrolled >= this.scrollRatio) this.show();
  }

  show() {
    if (this.seen() || this.dialog.open) return;
    document.body.classList.add('drawer-open');
    this.dialog.showModal();
    this.cleanup();
    const field = this.querySelector('input[type="email"]');
    if (field) field.focus();
  }

  dismiss() {
    this.markSeen();
    document.body.classList.remove('drawer-open');
    if (this.dialog.open) this.dialog.close();
  }

  cleanup() {
    clearTimeout(this.timer);
    window.removeEventListener('scroll', this.onScroll);
  }

  seen() {
    try {
      return localStorage.getItem(this.storageKey) === '1';
    } catch (e) {
      return false;
    }
  }

  markSeen() {
    try {
      localStorage.setItem(this.storageKey, '1');
    } catch (e) {}
  }
}
customElements.define('reserved-access-popup', ReservedAccessPopup);

/* Concatena DDI + número num campo único antes de enviar ao Shopify. */
document.addEventListener('submit', (event) => {
  const form = event.target.closest('[data-phone-form]');
  if (!form) return;
  const ddi = form.querySelector('[data-country-select]');
  const number = form.querySelector('[data-phone-number]');
  const full = form.querySelector('[data-phone-full]');
  if (ddi && number && full) {
    full.value = `${ddi.value}${number.value.replace(/\D/g, '')}`;
  }
});
